module.exports = __webpack_public_path__ + "img/marketing-dark.fb1339c8.svg";